import { render, staticRenderFns } from "./OmalizumabDialog.vue?vue&type=template&id=14d8727f&scoped=true&"
import script from "./OmalizumabDialog.vue?vue&type=script&lang=js&"
export * from "./OmalizumabDialog.vue?vue&type=script&lang=js&"
import style0 from "./OmalizumabDialog.vue?vue&type=style&index=0&id=14d8727f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d8727f",
  null
  
)

export default component.exports